import { render, staticRenderFns } from "./ExplorerFilterChips.vue?vue&type=template&id=671533d8"
import script from "./ExplorerFilterChips.vue?vue&type=script&lang=js"
export * from "./ExplorerFilterChips.vue?vue&type=script&lang=js"
import style0 from "./ExplorerFilterChips.vue?vue&type=style&index=0&id=671533d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports